// Directory: src/pages/HomePage.js
import React from "react";
// import Header from "../../components/landing/Header";
import HeroSection from "../../components/landing/HeroSection";
import SearchBar from "../../components/landing/SearchBar";
import CategorySection from "../../components/landing/CategorySection";
import FeaturedCars from "../../components/landing/FeaturedCars";
import Services from "../../components/landing/Services";
import Testimonials from "../../components/landing/Testimonials";
// import Footer from "../../components/landing/Footer";
import styles from "../../styles/HomePage.module.css";


const HomeCar = () => {
  
  return (
    <div className={styles.pageWrapper}>
      {/* <Header /> */}
      <HeroSection />
      <SearchBar />
      <CategorySection />
      <FeaturedCars />
      <Services />
      <Testimonials />
      {/* <Footer /> */}
    </div>
  );
};
export default HomeCar;
